// Same-origin HTTP-only cookies can restore a browser session without a readable
// token. Never enable cross-origin credentials or infer a role from cached data.
export function shouldProbeSession({ token, native, pathname, origin, backendUrl, cachedUser, cookieRestoreBlocked = false }) {
  if (cookieRestoreBlocked) return false;
  if (token) return true;
  if (native) return false;
  try {
    if (new URL(backendUrl).origin !== origin) return false;
  } catch { return false; }
  return !!cachedUser || /^\/(admin|vendor|dashboard|customer|account|settings)(\/|$)/.test(pathname);
}